// extracted by mini-css-extract-plugin
export default {"mainCard":"StartAppoinmentCard_mainCard__6qn8Z","textStart":"StartAppoinmentCard_textStart__r7SZr","iconDuo":"StartAppoinmentCard_iconDuo__XvXeM"};